import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-be31d5ac"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color" }
const _hoisted_2 = {
  key: 0,
  class: "hasdata"
}
const _hoisted_3 = {
  key: 0,
  class: "hasdata"
}

import { getDatesWithDataStation } from "@/service/estimation.service";
import { getSamplingPoints } from "@/service/samplingpoint.service";
import { SamplingPoint } from "@/types/samplingpoint.type";
import { getParameter } from "@/service/parameter.service";
import { Filter } from "@/types/filter.type";
import { Parameter } from "@/types/parameter.type";
import { ReportFilterStation } from "@/types/report.type";
import { FormInstance, FormRules } from "element-plus";
import { onMounted, reactive, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { ElMessage } from "element-plus";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {

const { t } = useI18n();

// - combos
const paramterers = ref<Parameter[]>([]);
const samplingPoint = ref<SamplingPoint[]>([]);

// - form
const form = ref<FormInstance | null>(null);
const reportFilter = reactive<ReportFilterStation>({
  samplingPointId: [],
  parameters: [],
  date: [null, null],
});

// - Data
const datesWithData = reactive<string[]>([]);
// - form validation
const rules = reactive<FormRules>({
  stationsIds: [
    {
      type: "array",
      required: true,
      message: t("error.required"),
      trigger: "change",
    },
  ],
});
// - date keys
const dateKey = ref(0);

// - VUE METHODS
/**
 * vue Hook
 */
onMounted(async () => {
  const filter: Filter = {
    fields: {
      "parameter.active": { operator: "equal", value: true },
      "parameter.type": { operator: "equal", value: "STATION" },
    },
  };
  paramterers.value = (await getParameter(undefined, undefined, filter))?.data || [];
  paramterers.value.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));

  samplingPoint.value = (await getSamplingPoints())?.data || [];
  samplingPoint.value.sort((a, b) => (a.name ?? "").localeCompare(b.name ?? ""));
});

/**
 * validate
 */
const validate = async () => {
  if (!form.value) {
    return;
  }
  let isValid = false;
  await form.value.validate((valid) => {
    isValid = valid;
  });

  return isValid;
};

/**
 * Fetch dates with data
 */
const getMarkedDates = async () => {
  if (reportFilter.samplingPointId.length > 0 && reportFilter.parameters.length > 0) {
    try {
      const response = await getDatesWithDataStation(
        reportFilter.samplingPointId,
        reportFilter.parameters
      );

      datesWithData.splice(
        0,
        datesWithData.length,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        ...response.map((data: any) => {
          const date = new Date(data.datastation_date);
          return date.toDateString();
        })
      );

      dateKey.value++;
    } catch (error) {
      ElMessage.error(t("error.fetchData"));
    }
  }
};

// watch dependencies for data fetching
watch(
  () => reportFilter.samplingPointId,
  () => {
    if (reportFilter.samplingPointId.length > 0 && reportFilter.parameters.length > 0) {
      getMarkedDates();
    }
  }
);

// watch for parameters changes
watch(
  () => reportFilter.parameters,
  () => {
    if (reportFilter.samplingPointId.length > 0 && reportFilter.parameters.length > 0) {
      getMarkedDates();
    }
  }
);

/***
 * PRUEBAS
 */

watch(
  () => reportFilter.samplingPointId,
  () => {
    // console.log(`[SamplingPoint]`, reportFilter.samplingPointId);
  }
);

watch(
  () => reportFilter.parameters,
  () => {
    if (reportFilter.samplingPointId.length > 0 && reportFilter.parameters.length > 0) {
      // console.log(`[algo]`, reportFilter.parameters);
    }
  }
);

watch(
  () => reportFilter.date[1],
  () => {
    if (
      reportFilter.date[0] !== null &&
      reportFilter.date[1] !== null &&
      reportFilter.date[0] > reportFilter.date[1]
    ) {
      ElMessage.error(t("error.wrongDate"));
    }
  }
);

watch(
  () => reportFilter.date[0],
  () => {
    if (
      reportFilter.date[0] !== null &&
      reportFilter.date[1] !== null &&
      reportFilter.date[0] > reportFilter.date[1]
    ) {
      ElMessage.error(t("error.wrongDate"));
    }
  }
);

/**
 * Saber cunado hay estimación
 * @param day
 */
const hasEstimatedData = (day: Date) => {
  return datesWithData.includes(day.toDateString());
};

// - VUE EXPOSE
expose({
  reportFilter,
  validate,
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(_component_el_form, {
    model: _unref(reportFilter),
    rules: _unref(rules),
    "label-position": "top",
    ref_key: "form",
    ref: form
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "stationIds",
                label: _unref(t)('label.samplingPoint')
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: _unref(reportFilter).samplingPointId,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(reportFilter).samplingPointId) = $event)),
                    multiple: "",
                    filterable: "",
                    style: {"width":"100%"},
                    "multiple-limit": 1
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(samplingPoint.value, (option) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: option.id,
                          label: option.name,
                          value: option.id
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_el_form_item, {
                  prop: "parameter",
                  label: _unref(t)('label.parameters')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: _unref(reportFilter).parameters,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(reportFilter).parameters) = $event)),
                      filterable: "",
                      multiple: "",
                      style: {"width":"100%"}
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paramterers.value, (option) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: option.id,
                            label: option.name,
                            value: option.code
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "date",
                label: _ctx.$t('label.fromDate')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_el_date_picker, {
                    modelValue: _unref(reportFilter).date[0],
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(reportFilter).date[0]) = $event)),
                    type: "datetime",
                    format: "YYYY-MM-DD HH:mm",
                    style: {"width":"100%"},
                    placeholder: "DD/MM/AAAA hh:mm",
                    key: 'from' + dateKey.value
                  }, {
                    default: _withCtx((cell) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["cell", { current: cell.isCurrent }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ text: true, nodata: !hasEstimatedData(cell.date) })
                        }, _toDisplayString(cell.text), 3),
                        (hasEstimatedData(cell.date))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_2))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_el_row, { gutter: 12 }, {
        default: _withCtx(() => [
          _createVNode(_component_el_col, { span: 24 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_form_item, {
                prop: "date2",
                label: _ctx.$t('label.endDate')
              }, {
                default: _withCtx(() => [
                  (_openBlock(), _createBlock(_component_el_date_picker, {
                    style: {"width":"100%"},
                    modelValue: _unref(reportFilter).date[1],
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(reportFilter).date[1]) = $event)),
                    placeholder: "DD/MM/AAAA hh:mm",
                    key: 'to' + dateKey.value,
                    type: "datetime",
                    format: "YYYY-MM-DD HH:mm"
                  }, {
                    default: _withCtx((cell) => [
                      _createElementVNode("div", {
                        class: _normalizeClass(["cell", { current: cell.isCurrent }])
                      }, [
                        _createElementVNode("span", {
                          class: _normalizeClass({ text: true, nodata: !hasEstimatedData(cell.date) })
                        }, _toDisplayString(cell.text), 3),
                        (hasEstimatedData(cell.date))
                          ? (_openBlock(), _createElementBlock("span", _hoisted_3))
                          : _createCommentVNode("", true)
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["modelValue"]))
                ]),
                _: 1
              }, 8, ["label"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["model", "rules"]))
}
}

})